import React from "react";
import { Select as AntSelect } from "antd";
import type { SelectProps } from "antd";

import "./stylesSelect.css";

export type SelectOwnProps<ValueType = unknown> = SelectProps<ValueType>;

const DROPDOWN_CLASS = "custom-form-select-dropdown";

function Select<ValueType = unknown>({
  className = "",
  virtual = true,
  classNames,
  ...props
}: SelectOwnProps<ValueType>) {
  const consumerPopupRoot =
    typeof classNames?.popup?.root === "string" ? classNames.popup.root : "";
  const popupRoot = [DROPDOWN_CLASS, consumerPopupRoot]
    .filter(Boolean)
    .join(" ");

  return (
    <AntSelect<ValueType>
      {...props}
      className={`custom-form-select ${className}`.trim()}
      virtual={virtual}
      classNames={{
        ...classNames,
        popup: {
          ...classNames?.popup,
          root: popupRoot,
        },
      }}
    />
  );
}

export default Select;
